import React from 'react';
import PropTypes from 'prop-types';
import style from '@src/js/Style';
import BadgeCard from '../Base/BadgeCard';
import NumberFormatter from '../../NumberFormatter';
import Api from '../../Api';

export default class History extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            items: null,
        };

        this.update();
    }

    static get propTypes() {

        return {
            calculatorId: PropTypes.any,
            currencyIso: PropTypes.string,
        };
    }

    update() {

        Api
            .fetch(`${Api.origin}/api/v2/calc/history.json?calculatorId=${ this.props.calculatorId }`)
            .then((response) => {

                this.setState({ items: response.history });
            });
    }

    render() {

        if (this.state.items == null)
            return null;

        return (
            <div className={ style('flex-grid-4') }>
                { this.state.items.map((item) => (
                    <BadgeCard key={ item.id }>
                        <a target='_blank' href={ item.url } className={ style('text-black flex flex-center gap rounded') }>

                            { this.renderLogo(item) }
                            
                            <div className={ style('flex flex-wrap flex-1') }>
                                <div className={ style('flex items-center gap-sm') }>
                                
                                    {/* price */}
                                    <nobr className={ style('text-bold') }>
                                        { NumberFormatter.parseEx(item?.price, {
                                            currency: { iso: this.props.currencyIso },
                                        }).formatted() }
                                    </nobr>

                                </div>

                                <div className={ style('flex gap-md w-full text-small text-muted') }>
                                    <nobr>
                                        { NumberFormatter.parseEx(item?.term, { currency: item?.unit }).formatted() }
                                    </nobr>
                                    /
                                    <nobr>
                                        { NumberFormatter.parseEx(item?.rate, { currency: '%' }).formatted() }
                                    </nobr>
                                </div>
                            </div>

                        </a>
                    </BadgeCard>
                )) }
            </div>
        );
    }

    renderLogo(item) {

        if (!item.logo)
            return null;

        return <img
            className={ style('size-24 object-contain') }
            alt={ item?.logo_alt }
            src={ item.logo } />;
    }
    
}